import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { timeFormatUi } from '../../../constants/date';
import { renderDateWithTimeZone } from '../../../helpers/timezones';
import { appPath } from '../../../constants';
import { labels } from '../../../constants/text';

export default class JobInfo extends PureComponent {
  static propTypes = {
    jobData: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    shouldHide: PropTypes.object.isRequired
  };

  navToEvent = e => {
    e.preventDefault();
    const { history, jobData: { event_id } } = this.props;
    history.push(`/${appPath}/events/${event_id}`);
  };

  _renderJobOwner = () => {
    const { jobData: { employer, status } } = this.props;

    if (!employer) {
      return null;
    }

    const { is_company, company_name, first_name, last_name } = employer;
    const displayName = is_company ? company_name : `${first_name} ${last_name}`;

    return <p className={`name no-wrap ${status}`}>{displayName}</p>;
  };

  _renderBadge = () => {
    const { is_lta, event_id, status } = this.props.jobData;

    if (!event_id) {
      return null;
    }

    const label = is_lta ? labels.lta : labels.event;

    return (
      <div
        className={`badge-job badge-${status}`}
        onClick={this.navToEvent}
      >
        {label}
      </div>
    );
  };

  render () {
    const { id, status, address, location_name, skill_label, start_date, time_zone_id, hours,
      quantity_of_workers, hired_quantity } = this.props.jobData;
    const displayLocation = location_name || address;
    const jobTime = renderDateWithTimeZone(start_date, timeFormatUi, time_zone_id);
    const canHide = status.toString() === 'filled'
    console.log(`canhide for id ${id} is `, canHide)
    return (
      <Link
        className={`dashboard-item-wrapper ${status}`}
        style={{ display: (canHide && this.props.shouldHide) ? 'none' : 'inherit' }}
        to={`/${appPath}/jobs/${id}`}
      >
        {this._renderJobOwner()}

        <p className='no-wrap'>{displayLocation}</p>
        <p>{skill_label}</p>
        <p>{jobTime} for {hours} hrs</p>
        <div className='d-flex align-items-center justify-content-between'>
          <span>{`${hired_quantity} / ${quantity_of_workers}`}</span>

          {this._renderBadge()}
        </div>
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/dashboard/JobInfo.js